import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=170edaae&scoped=true&"
import script from "./CouponDetail.vue?vue&type=script&lang=js&"
export * from "./CouponDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=170edaae&lang=less&scoped=true&"
import style1 from "./CouponDetail.vue?vue&type=style&index=1&id=170edaae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170edaae",
  null
  
)

export default component.exports